import { defineNuxtPlugin } from '#app'
import PrimeVue from 'primevue/config'
import { defineAsyncComponent } from 'vue'
import AccordionTab from 'primevue/accordiontab'
import Avatar from 'primevue/avatar'
import AvatarGroup from 'primevue/avatargroup'
import Badge from 'primevue/badge'
import Button from 'primevue/button'
import Card from 'primevue/card'
import Column from 'primevue/column'
import Divider from 'primevue/divider'
import Image from 'primevue/image'
import Menubar from 'primevue/menubar'
import StepperPanel from 'primevue/stepperpanel'
import TabPanel from 'primevue/tabpanel'
import Tag from 'primevue/tag'
import Toast from 'primevue/toast'
import ToastService from 'primevue/toastservice'

export default defineNuxtPlugin(nuxtApp => {
  const { vueApp } = nuxtApp

  vueApp.use(PrimeVue, { ripple: true })
  vueApp.component('AccordionTab', AccordionTab)
  vueApp.component('Avatar', Avatar)
  vueApp.component('AvatarGroup', AvatarGroup)
  vueApp.component('Badge', Badge)
  vueApp.component('Button', Button)
  vueApp.component('Card', Card)
  vueApp.component('Column', Column)
  vueApp.component('Divider', Divider)
  vueApp.component('Image', Image)
  vueApp.component('Menubar', Menubar)
  vueApp.component('StepperPanel', StepperPanel)
  vueApp.component('TabPanel', TabPanel)
  vueApp.component('Tag', Tag)
  vueApp.component('Toast', Toast)

  const asyncComponents = {
    Accordion: () => import('primevue/accordion'),
    Calendar: () => import('primevue/calendar'),
    DataTable: () => import('primevue/datatable'),
    DeferredContent: () => import('primevue/deferredcontent'),
    Dialog: () => import('primevue/dialog'),
    Dropdown: () => import('primevue/dropdown'),
    IconField: () => import('primevue/iconfield'),
    InputGroup: () => import('primevue/inputgroup'),
    InputIcon: () => import('primevue/inputicon'),
    InputText: () => import('primevue/inputtext'),
    Paginator: () => import('primevue/paginator'),
    ProgressSpinner: () => import('primevue/progressspinner'),
    ScrollPanel: () => import('primevue/scrollpanel'),
    Stepper: () => import('primevue/stepper'),
    TabView: () => import('primevue/tabview'),
    Textarea: () => import('primevue/textarea'),
    TriStateCheckbox: () => import('primevue/tristatecheckbox'),
  }

  Object.entries(asyncComponents).forEach(([name, importComponent]) => {
    vueApp.component(name, defineAsyncComponent(importComponent))
  })

  vueApp.use(ToastService)
})
